import ClarityMethods from '@microsoft/clarity';

import { FeaturesRequest } from '@/app/libs/sentry/types/features';
import { captureException } from '@/app/libs/sentry/utils/exception';

type Args = string | boolean | undefined | string[];

function getArgs<T extends Args[]>(args: T) {
  try {
    return Object.fromEntries(Object.entries(args));
  } catch {
    return {};
  }
}

function errorHandler<T extends Args[]>(error: unknown, args: T) {
  if (!(error instanceof Error)) return;

  if (error.message === `window.clarity is not a function`) {
    return;
  }

  captureException(error, FeaturesRequest.CLARITY, getArgs(args));
}

export const Clarity: typeof ClarityMethods = {
  init: (...args: Parameters<typeof ClarityMethods.init>) => {
    try {
      return ClarityMethods.init(...args);
    } catch (error) {
      errorHandler(error, args);
    }
  },

  event: (...args: Parameters<typeof ClarityMethods.event>) => {
    try {
      return ClarityMethods.event(...args);
    } catch (error) {
      errorHandler(error, args);
    }
  },

  setTag: (...args: Parameters<typeof ClarityMethods.setTag>) => {
    try {
      return ClarityMethods.setTag(...args);
    } catch (error) {
      errorHandler(error, args);
    }
  },

  upgrade: (...args: Parameters<typeof ClarityMethods.upgrade>) => {
    try {
      return ClarityMethods.upgrade(...args);
    } catch (error) {
      errorHandler(error, args);
    }
  },

  consent: (...args: Parameters<typeof ClarityMethods.consent>) => {
    try {
      return ClarityMethods.consent(...args);
    } catch (error) {
      errorHandler(error, args);
    }
  },

  identify: (...args: Parameters<typeof ClarityMethods.identify>) => {
    try {
      return ClarityMethods.identify(...args);
    } catch (error) {
      errorHandler(error, args);
    }
  },
};
